module.exports = __webpack_public_path__ + "img/mapdot.e237988d.svg";